import React, { useEffect } from 'react';
import { Form, Input, Button, Row, Col, Space, Select } from 'antd';
import emiter, { EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST } from '../../../../events';
import {DEFAULT_PAGE_INFO} from "../../../../consts";
interface PropsType {
	enums?: any;
}

const SPEmployeeListSearchForm: React.FC<PropsType> = props => {
	const { enums } = props;

	const searchFormFields = {
		xingming: {
			name: 'user_name',
			label: '姓名',
			required: false,
			message: '请输入姓名',
			placeholder: '请输入',
		},
		shoujihao: {
			name: 'cell_encrypt',
			label: '手机号',
			required: false,
			message: '请输入手机号',
			placeholder: '请输入',
		},
		zhuangtai: {
			name: 'user_status',
			label: '状态',
			required: false,
			message: '请选择状态',
			placeholder: '全部',
		},
	};

	const [searchForm] = Form.useForm();

	const onSearchFormReset = () => {
		searchForm.resetFields();
		emiter.emit(EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST, {
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	};

	const onSearchFormFinish = () => {
		emiter.emit(
			EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST,
      {
        ...searchForm.getFieldsValue(),
        ...DEFAULT_PAGE_INFO
      }
		);
	};

	useEffect(() => {
		// emiter.on(EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST, onSearchFormFinish);
	}, []);

	return (
		<Form form={searchForm} onFinish={onSearchFormFinish}>
			<Row gutter={24}>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.xingming.name}
						label={searchFormFields.xingming.label}
						rules={[
							{
								required: searchFormFields.xingming.required,
								message: searchFormFields.xingming.message,
							},
						]}
					>
						<Input placeholder={searchFormFields.xingming.placeholder} allowClear />
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.shoujihao.name}
						label={searchFormFields.shoujihao.label}
						rules={[
							{
								required: searchFormFields.shoujihao.required,
								message: searchFormFields.shoujihao.message,
							},
						]}
					>
						<Input placeholder={searchFormFields.shoujihao.placeholder} allowClear />
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.zhuangtai.name}
						label={searchFormFields.zhuangtai.label}
						rules={[
							{
								required: searchFormFields.zhuangtai.required,
								message: searchFormFields.zhuangtai.message,
							},
						]}
					>
						<Select placeholder={searchFormFields.zhuangtai.placeholder} allowClear>
							{enums?.user_status?.map((item: any) => (
								<Select.Option key={item.key} value={item.key}>
									{item.value}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
			</Row>
			<Space size="small">
				<Button type="primary" onClick={onSearchFormFinish}>
					查询
				</Button>
				<Button onClick={onSearchFormReset}>清空</Button>
			</Space>
		</Form>
	);
};

export default SPEmployeeListSearchForm;
